import {parseAction} from "../parseAction";
import {
    getAmountsInAPI,
    getAmountsOutAPI,
    getMainNetInfoAPI,
    getSwapLimitAPI,
    getSwapPairAPI, getSwapsAPI,
} from "../../server/swap";
import {getCoinBalanceAPI} from "../../server/blockExplorer";
import {getERC20BalanceAPI} from "../../server/microChainCurrency";
import {getWrapTokensWithCurrency} from "./private";
import {Currency} from "server/walletManage/type";
import {isCoin} from "utils/chainUtil";
import {WrapTokenWithCurrency} from "reducer/swap/type";
import {requestEasySwap} from "modules/Whisper";
import swap from "../../view/page/Swap";
import {WrapToken} from "../../server/swap/type";

export const initSwapAction = () =>
  parseAction(async () => {
    const mainNetInfo = await getMainNetInfoAPI.request();
    const wrapTokens = await getWrapTokensWithCurrency()
    return {
      mainNetInfo,
      wrapTokens,
    };
  });

export const getSwapPairAction = (args: { wrapTokenId: number }) =>
  parseAction(async () => {
    const swapPairIds = await getSwapPairAPI.request({
      query: args,
    });
    const swapPairWrapTokens = await getWrapTokensWithCurrency({
      query: {
        wrapTokenIdList: swapPairIds,
      },
    });
    return swapPairWrapTokens;
  });

export const getCurrencyBalanceAction = (args: {
  currency: Currency;
  address: string;
}) =>
  parseAction(async () => {
    const { currency, address } = args;
    const { microChainId, microChainCurrencyId } = currency;

    if (isCoin(currency)) {
      return await getCoinBalanceAPI.request({
        query: {
          microChainId,
          address,
        },
      });
    } else {
      return await getERC20BalanceAPI.request({
        params: {
          microChainCurrencyId,
        },
        query: {
          microChainId,
          address,
        },
      });
    }
  });

export const getSwapLimitAciton = (args: { unit: string, fromTokenId: number, toTokenId: number }) =>
  parseAction(async () => {
    const { unit, fromTokenId, toTokenId } = args;
    const { max, min } = await getSwapLimitAPI.request({
      query: {
        unit,
        fromTokenId,
        toTokenId
      },
    });
    return { max, min };
  });

export const getTokenAmountsInAction = (args: {
  amountOut: string;
  inContractAddress: string;
  outContractAddress: string;
}) =>
  parseAction(async () => {
    const { amounts, totalNetworkFee } = await getAmountsInAPI.request({
      query: args,
    });
    return { amounts, totalNetworkFee };
  });

export const getTokenAmountsOutAction = (args: {
  amountIn: string;
  inContractAddress: string;
  outContractAddress: string;
}) =>
  parseAction(async () => {
    const { amounts, totalNetworkFee } = await getAmountsOutAPI.request({
      query: args,
    });
    return { amounts, totalNetworkFee };
  });

export const makeSwapTransactionAction = (args: {
  tokenIn: WrapTokenWithCurrency;
  tokenInAmount: string;
  tokenOut: WrapTokenWithCurrency;
  tokenOutAmount: string;
  totalNetworkFee: string;
}) =>
  parseAction(async () => {
    const {
      tokenIn,
      tokenInAmount,
      tokenOut,
      tokenOutAmount,
      totalNetworkFee,
    } = args;

    const easySwapData = {
      fromTokenId: tokenIn.wrapTokenId,
      fromTokenValue: tokenInAmount,
      toTokenId: tokenOut.wrapTokenId,
      toTokenValue: tokenOutAmount,
      totalNetworkFee,
    };
      return await requestEasySwap(easySwapData);
  });

export const getSwapHistoriesAction = ({
    address,
    limit,
    lastId,
    wrapTokens,
}: {
    address: string,
    limit: number,
    lastId: number,
    wrapTokens: WrapTokenWithCurrency[],
}) => parseAction(async () => {

    const histories = await Promise.all(wrapTokens.map(async (wrapToken) => await getSwapsAPI.request({
            query: {
                walletAddress: address,
                limit,
                lastId,
                toTokenId: wrapToken.wrapTokenId,
            }
        })
    ));

    // @ts-ignore
    const sortedHistories = _.sortBy(histories
        .reduce((acc, cur) => [...acc, ...cur], []), 'swapId').reverse();

    return sortedHistories.slice(0, limit)
})
